import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AbstractService } from 'src/app/services/abstract.service';
import { IntegracaoDeskService, StatusEnvioDesk } from 'src/app/services/integracao-desk.service';

@Component({
  selector: 'habil-integracao-desk',
  templateUrl: './integracao-desk.component.html',
  styleUrls: ['./integracao-desk.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class IntegracaoDeskComponent implements OnInit, OnDestroy {

  status: StatusEnvioDesk;
  carregando = true;
  enviando = false;

  private timer: any;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private service: IntegracaoDeskService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    titleService: Title) {
    this.breadcrumbService.setItems([{ label: 'Enviar todos os clientes para o Desk' }]);
    titleService.setTitle('Enviar clientes para o Desk - ' + AbstractService.app);
  }

  ngOnInit(): void {
    this.atualizar();
  }

  ngOnDestroy(): void {
    clearTimeout(this.timer);
  }

  get progresso(): number {
    const total = this.status?.total || 0;
    if (!total) {
      return 0;
    }
    return Math.round(((this.status.processados || 0) / total) * 100);
  }

  confirmarEnvio() {
    this.confirmationService.confirm({
      header: 'Atenção',
      message: 'Enviar todos os clientes da central para o Habil Desk? O envio roda em segundo plano, em lotes de 100 clientes.',
      rejectLabel: 'Não',
      acceptLabel: 'Sim',
      accept: () => this.enviar(),
    });
  }

  private enviar() {
    this.enviando = true;
    this.service.enviarTodos().subscribe({
      next: (status) => {
        this.enviando = false;
        this.status = status;
        this.messageService.add({ severity: 'success', summary: 'Envio iniciado', detail: 'Os clientes estão sendo enviados para o Desk.' });
        this.agendar();
      },
      error: (e) => {
        this.enviando = false;
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: e?.error || 'Não foi possível iniciar o envio.' });
        this.atualizar();
      }
    });
  }

  private atualizar() {
    clearTimeout(this.timer);
    this.service.status().subscribe({
      next: (status) => {
        this.carregando = false;
        this.status = status;
        if (status?.emAndamento) {
          this.agendar();
        }
      },
      error: (e) => {
        this.carregando = false;
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: e?.error || 'Não foi possível consultar o envio.' });
      }
    });
  }

  private agendar() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.atualizar(), 3000);
  }
}
